/**
 * Novelune 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  avatarBorder: brandTheme.borderPrimary,
  btnPrimaryBg: 'rgba(255, 138, 76, 0.08)',
  topUpBtnBg: 'linear-gradient(90deg, #FFD4B8 0%, #FFA876 100%)',
  vipSubscribeBg: 'url(/images/novelune/member_subscribe_bg.webp)',
  subscribeBg: 'linear-gradient(100deg, #FFF5EE 0%, #FFEDE4 60%, #FFE5D7 100%)',
  subscribeText: '#B8643D',
  subscribeText2: 'rgba(184, 100, 61, 0.58)',
  vipBtnBg: brandTheme.primaryGradient || 'linear-gradient(90deg, #FFBC7A 0%, #FF6B3D 100%)',
} as const

export const resources = {
  memberBg: '',
  userBg: '',
  userDefaultAvatar: '/images/novelune/user-default.svg?v=3',
  memberVip: '/images/novelune/member-vip.png',
  memberVipDiscount: '/images/novelune/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
